import { type ReactNode } from 'react'

import { StyledContent } from '@/components/common/StyledContent'
import { Icon } from '@/components/icons/Icon'
import { type IconType } from '@/defs/icon'
import { cn } from '@/utils/commonUtil'

import styles from './AlertBox.module.scss'

type VariantType = 'warning' | 'info' | 'success'

type Props = {
  children: ReactNode
  icon?: IconType
  variant?: VariantType
}

const DEFAULT_ICONS: Record<VariantType, IconType> = {
  info: 'circleExclamation',
  success: 'circleCheck',
  warning: 'circleXmark',
}

export const AlertBox = ({ children, icon: iconProp, variant = 'warning' }: Props) => {
  const icon = iconProp || DEFAULT_ICONS[variant]

  return (
    <div className={cn(styles.container, { styles, variant })}>
      <span className={styles.icon}>
        <Icon name={icon} />
      </span>
      <StyledContent>{children}</StyledContent>
    </div>
  )
}
